import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatHours } from "@activecollab/components";
import PropTypes from "prop-types";
import { getSelectedJobTypeName } from "~/store/selectors/selector.jobTypes.jsx";

const TimeEstimateAsLabelContainer = ({ value, id }) => {
  const name = useSelector((state) => getSelectedJobTypeName(state, id));

  const { t } = useTranslation();

  const preparedText = useMemo(() => {
    return t("{{hours}} of {{job_type}}", {
      hours: formatHours(value),
      job_type: name,
    });
  }, [name, t, value]);

  return <span>{preparedText}</span>;
};

TimeEstimateAsLabelContainer.propTypes = {
  value: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default TimeEstimateAsLabelContainer;
